export enum TYPE_OF_BUILDING {
  APARTMENT = 'wohnung',
  HOUSE = 'einZweiFamilienhaus',
}

export const TYPE_OF_BUILDING_LABEL: {
  [key in TYPE_OF_BUILDING]: string;
} = {
  [TYPE_OF_BUILDING.APARTMENT]: 'Wohnung',
  [TYPE_OF_BUILDING.HOUSE]: 'Ein/-Zweifamilienhaus',
};

export enum TYPE_OF_BUILDING_USAGE {
  OWNER = 'eigentuemer',
  TENANT = 'mieter',
}

export const TYPE_OF_BUILDING_USAGE_LABEL: {
  [key in TYPE_OF_BUILDING_USAGE]: string;
} = {
  [TYPE_OF_BUILDING_USAGE.OWNER]: 'Eigentümer',
  [TYPE_OF_BUILDING_USAGE.TENANT]: 'Mieter',
};
